import { ProductKeys3P } from '../../../../constants/product-keys';

/**
 * Fallback order when smartlink usage data isn't available. Only includes
 * products that are commonly connected across workspaces.
 */
export const STATIC_FALLBACK_ORDER: readonly ProductKeys3P[] = [
	ProductKeys3P.GoogleDrive,
	ProductKeys3P.Salesforce,
	ProductKeys3P.Slack,
	ProductKeys3P.Github,
	ProductKeys3P.Figma,
];
